import { render, staticRenderFns } from "./ListVehiclePart.vue?vue&type=template&id=64ad0c75"
import script from "./ListVehiclePart.vue?vue&type=script&lang=js"
export * from "./ListVehiclePart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListVehiclePart.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ad0c75')) {
      api.createRecord('64ad0c75', component.options)
    } else {
      api.reload('64ad0c75', component.options)
    }
    module.hot.accept("./ListVehiclePart.vue?vue&type=template&id=64ad0c75", function () {
      api.rerender('64ad0c75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fleet/src/components/ListVehiclePart.vue"
export default component.exports